import Combine from '../../components/Combine/Combine'
import MarketPlace from './LearningTools'

const Marketing = () => {
  return (
   <Combine>
    <MarketPlace/>
   </Combine>
  )
}

export default Marketing
